/**
 * @generated SignedSource<<5720d725e5e80f2b1872f8f01a08c1fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aggregated"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "category"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "round"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v3 = {
  "kind": "Variable",
  "name": "aggregated",
  "variableName": "aggregated"
},
v4 = {
  "kind": "Variable",
  "name": "category",
  "variableName": "category"
},
v5 = {
  "kind": "Variable",
  "name": "round",
  "variableName": "round"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryPosition",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flightId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Flight",
  "kind": "LinkedField",
  "name": "flight",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startingHole",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFavorite",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finishedHoles",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flightStatus",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previousCategoryPosition",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previousPosition",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strokes",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nationality",
  "storageKey": null
},
v21 = [
  (v20/*: any*/),
  (v7/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LeaderboardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Tournament",
        "kind": "LinkedField",
        "name": "tournament",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LeaderboardSearch_tournament"
          },
          {
            "args": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "Leaderboard_tournament"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LeaderboardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Tournament",
        "kind": "LinkedField",
        "name": "tournament",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TournamentRound",
            "kind": "LinkedField",
            "name": "tournamentRounds",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "round",
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v5/*: any*/)
            ],
            "concreteType": "TournamentRound",
            "kind": "LinkedField",
            "name": "tournamentRound",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "concreteType": "FlightScore",
                "kind": "LinkedField",
                "name": "rankedFlightScores",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aggregateCategoryPosition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aggregatePosition",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Player",
                    "kind": "LinkedField",
                    "name": "player",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v7/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aggregateScore",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aggregateStrokes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aggregateFinishedHoles",
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Pair",
                    "kind": "LinkedField",
                    "name": "pair",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "playerA",
                        "plural": false,
                        "selections": (v21/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "playerB",
                        "plural": false,
                        "selections": (v21/*: any*/),
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TournamentPlayer",
                    "kind": "LinkedField",
                    "name": "tournamentPlayer",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Player",
                        "kind": "LinkedField",
                        "name": "player",
                        "plural": false,
                        "selections": (v21/*: any*/),
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activeRound",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "useBestRound",
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TournamentRound",
            "kind": "LinkedField",
            "name": "activeTournamentRound",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shotgun",
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organisation",
            "kind": "LinkedField",
            "name": "organisation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v4/*: any*/)
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "rankedEntries",
            "plural": true,
            "selections": [
              (v22/*: any*/),
              (v7/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlightScore",
                    "kind": "LinkedField",
                    "name": "activeFlightScore",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v12/*: any*/),
                      (v7/*: any*/),
                      (v22/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v17/*: any*/),
                      (v16/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlightScore",
                    "kind": "LinkedField",
                    "name": "flightScores",
                    "plural": true,
                    "selections": [
                      (v14/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "FlightScoresInterface",
                "abstractKey": "__isFlightScoresInterface"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Player",
                    "kind": "LinkedField",
                    "name": "player",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "TournamentPlayer",
                "abstractKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isRankedEntry"
              },
              (v2/*: any*/),
              (v20/*: any*/),
              (v6/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c8b5ecea526dd4b94a2fd5a597a794af",
    "id": null,
    "metadata": {},
    "name": "LeaderboardQuery",
    "operationKind": "query",
    "text": "query LeaderboardQuery(\n  $aggregated: Boolean\n  $category: String\n  $id: ID!\n  $round: Int\n) {\n  tournament(id: $id) {\n    databaseId\n    ...LeaderboardSearch_tournament\n    ...Leaderboard_tournament_3kfNC4\n    id\n  }\n}\n\nfragment FinishedHoles_tournament on Tournament {\n  status\n  activeTournamentRound {\n    shotgun\n    id\n  }\n}\n\nfragment LeaderboardSearch_tournament on Tournament {\n  ...RoundSelector_tournament\n}\n\nfragment LeaderboardTableEntry_flightScore on FlightScore {\n  aggregateCategoryPosition\n  aggregatePosition\n  aggregateScore\n  aggregateStrokes\n  aggregateFinishedHoles\n  categoryPosition\n  finishedHoles\n  flightStatus\n  id\n  name\n  position\n  previousCategoryPosition\n  previousPosition\n  score\n  strokes\n  flight {\n    id\n    startingHole\n  }\n  pair {\n    databaseId\n    status\n    playerA {\n      nationality\n      id\n    }\n    playerB {\n      nationality\n      id\n    }\n    id\n  }\n  player {\n    databaseId\n    id\n  }\n  tournamentPlayer {\n    status\n    player {\n      nationality\n      id\n    }\n    id\n  }\n}\n\nfragment LeaderboardTableEntry_tournament on Tournament {\n  activeRound\n  ...FinishedHoles_tournament\n  ...Position_tournament\n  ...ScoreTotal_tournament\n}\n\nfragment LeaderboardTableOverallEntry_rankedEntry on RankedEntry {\n  __isRankedEntry: __typename\n  __typename\n  databaseId\n  id\n  name\n  nationality\n  position\n  status\n  score\n  strokes\n  ... on FlightScoresInterface {\n    __isFlightScoresInterface: __typename\n    activeFlightScore {\n      __typename\n      id\n      finishedHoles\n      flightStatus\n      previousPosition\n      previousCategoryPosition\n      score\n      flight {\n        id\n        startingHole\n      }\n    }\n    flightScores {\n      finishedHoles\n      id\n    }\n  }\n  ... on TournamentPlayer {\n    categoryPosition\n  }\n}\n\nfragment LeaderboardTableOverallEntry_tournament on Tournament {\n  activeRound\n  useBestRound\n  ...FinishedHoles_tournament\n  ...Position_tournament\n  ...ScoreTotal_tournament\n}\n\nfragment LeaderboardTableOverall_tournament_15BdcN on Tournament {\n  activeRound\n  rankedEntries(category: $category) {\n    __typename\n    id\n    name\n    position\n    ... on FlightScoresInterface {\n      __isFlightScoresInterface: __typename\n      activeFlightScore {\n        flightId\n        flight {\n          startDate\n          id\n        }\n        id\n      }\n    }\n    ... on TournamentPlayer {\n      categoryPosition\n      player {\n        isFavorite\n        id\n      }\n    }\n    ...LeaderboardTableOverallEntry_rankedEntry\n  }\n  ...LeaderboardTableOverallEntry_tournament\n}\n\nfragment LeaderboardTable_tournamentRound_lE5XJ on TournamentRound {\n  rankedFlightScores(aggregated: $aggregated, category: $category) {\n    aggregateCategoryPosition\n    aggregatePosition\n    categoryPosition\n    flightId\n    id\n    name\n    position\n    flight {\n      startDate\n      id\n    }\n    player {\n      isFavorite\n      id\n    }\n    ...LeaderboardTableEntry_flightScore\n  }\n}\n\nfragment LeaderboardTable_tournament_15BdcN on Tournament {\n  activeRound\n  useBestRound\n  ...LeaderboardTableEntry_tournament\n  ...LeaderboardTableOverall_tournament_15BdcN\n}\n\nfragment Leaderboard_tournament_3kfNC4 on Tournament {\n  tournamentRound(round: $round) {\n    ...LeaderboardTable_tournamentRound_lE5XJ\n    id\n  }\n  ...LeaderboardTable_tournament_15BdcN\n  id\n}\n\nfragment Position_tournament on Tournament {\n  activeRound\n}\n\nfragment RoundSelector_tournament on Tournament {\n  tournamentRounds {\n    round\n    status\n    id\n  }\n}\n\nfragment ScoreTotal_tournament on Tournament {\n  activeRound\n  organisation {\n    color\n    id\n  }\n}\n"
  }
};
})();

node.hash = "9013ba12550b347dbaf64e666a822ab9";

module.exports = node;
